(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gemelli-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gemelli-product-video')) {
    customElements.define('gemelli-product-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button') || this.closest('.card-gallery')?.querySelector('[data-gemelli-card-toggle]');
        if (!this.video || !this.button) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.userPaused = false;
        this.visible = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.video.muted = true;
        const update = () => {
          const playing = !this.video.paused;
          this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
          this.button.firstElementChild.textContent = playing ? 'Ⅱ' : '▶';
        };
        this.video.addEventListener('play', update, { signal });
        this.video.addEventListener('pause', update, { signal });
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.video.paused) {
            this.userPaused = false;
            this.video.play().catch(() => {});
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, { signal });
        this.sync = () => {
          if (this.visible && !document.hidden && !this.userPaused && !this.motion.matches) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
          this.sync();
        }, { threshold: [0, 0.5] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', this.sync, { signal });
        this.motion.addEventListener('change', this.sync, { signal });
        update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
